export default {
  'label/my_profile': 'Meu Perfil',
  'label/my_record': 'Meu Cadastro',
  'label/change_password': 'Alterar Senha',
  'label/old_password': 'Senha Antiga',
  'label/old_password_success': 'Senha alterada com sucesso',
  'label/new_password': 'Senha Nova',
  'label/clinic_logo': 'Logo da Clínica',
  'label/mail_accept_text': 'Quero receber e-mails ocasionais de treinamento e suporte (promessa: jamais enviaremos spam)',
  // privacy
  'label/records_privacy/title': 'Privacidade dos Registros no Prontuário',
  'label/records_privacy/opt/input_desctiption': 'Quem pode ver o prontuário dos seus pacientes?',
  'label/records_privacy/opt/only_me': 'Somente Eu',
  'label/records_privacy/opt/doctors': 'Doutores - Somente os doutores da clínica',
  'label/records_privacy/opt/all': 'Todos - Doutores e secretárias da clínica',
  'label/records_privacy/loading': 'Carregando dados do usuário',
  // custom forms
  'label/custom_forms/forms_list': 'Lista de Formulários',
  'label/custom_forms/text1': 'Clientes dos planos Concierge e Clínica podem editar, excluir ou adicionar um novo formulário.',
  'label/custom_forms/contact_text': 'Entre em contato com nosso Chat Online para editar seus formulários',
  'label/rich_text_editor/title': 'Editor do prontuário',
  'label/rich_text_editor/switch': 'Editor com formatação',
  'label/rich_text_editor/description': 'Destaque, negrito e listas no prontuário',
  // prescription menu
  'label/prescription_menu/title': 'Receituário Eletrônico',
  'label/prescription_menu/prescriptions': 'Modelos de Prescrição',
  'label/prescription_menu/exams': 'Modelos de Pedido de Exames',
  'label/prescription_menu/docs': 'Modelos de Documento',
  'label/prescription_menu/memed': 'Memed',
  // memed settings
  'memed/title': 'Memed',
  'memed/intro': 'Conecte sua conta à Memed para fazer receitas digitais no prontuário. O Doutore confere seus dados com o CFM e cadastra você na Memed na hora.',
  'memed/intro_other_board': 'Conecte sua conta à Memed para fazer receitas digitais no prontuário. Para registros no {{board}}, a Memed também revisa o seu cadastro.',
  'memed/form/name': 'Nome completo, como no seu registro',
  'memed/form/cpf': 'CPF',
  'memed/form/cpf_hint': 'O seu CPF, não o de quem paga a assinatura.',
  'memed/form/birth_date': 'Data de nascimento',
  'memed/form/council_doc': 'Número do {{board}}',
  'memed/form/council_state': 'Estado do {{board}}',
  'memed/form/gender': 'Sexo',
  'memed/form/consent': 'Autorizo o envio destes dados à Memed, para o meu cadastro de receita digital.',
  'memed/form/save': 'Conectar à Memed',
  'memed/form/saving': 'Validando com o CFM…',
  'memed/form/saving_other_board': 'Conectando à Memed…',
  'memed/error/name': 'Informe o nome completo, com sobrenome.',
  'memed/error/birth_date': 'Data inválida.',
  'memed/error/council_doc': 'Só os números do registro.',
  'memed/error/consent': 'Marque a autorização para continuar.',
  'memed/error/load': 'Não conseguimos carregar seus dados da Memed.',
  'memed/error/retry': 'Tentar de novo',
  'memed/connected/title': 'Sua conta está conectada à Memed',
  'memed/connected/text': 'Para fazer uma receita digital, abra o prontuário de um paciente e clique em Nova Receita Memed.',
  'memed/connected/review': 'A Memed revisa os registros no {{board}}: até ela confirmar o seu, a receita pode não abrir.',
  'memed/connected/back': 'Voltar ao prontuário',
  'memed/support': 'Algum problema?',
  'memed/support/button': 'Falar com o suporte',
  // google agenda
  'google_calendar/title': 'Google Agenda',
  'google_calendar/point/calendar': 'Suas consultas aparecem numa agenda “Doutore” no seu Google Agenda, no celular e no computador.',
  'google_calendar/point/meet': 'Consultas online ganham um link próprio do Google Meet, que vai para o paciente na confirmação.',
  'google_calendar/point/privacy': 'Só o primeiro nome e a inicial do sobrenome do paciente vão para o Google. Anotações e prontuário não vão.',
  'google_calendar/connected': 'Conectado',
  'google_calendar/connected_as': 'Conectado como',
  'google_calendar/not_connected': 'Não conectado',
  'google_calendar/connect': 'Conectar Google Agenda',
  'google_calendar/disconnect': 'Desconectar',
  'google_calendar/opened': 'Entre com sua conta Google na página que abriu e depois volte para o Doutore.',
  'google_calendar/error/load': 'Não foi possível carregar o Google Agenda. Confira sua internet e tente de novo.',
  'google_calendar/retry': 'Tentar de novo',
  'google_calendar/paywall/title': 'O Google Agenda faz parte dos planos Completo e acima',
  'google_calendar/paywall/upgrade': 'Faça upgrade para ver suas consultas no Google Agenda e ter um link próprio do Google Meet em cada consulta online.',
  'google_calendar/paywall/ask_owner': 'Fale com o responsável pela clínica para mudar o plano e liberar o Google Agenda.',
  'google_calendar/paywall/paused': 'O plano da clínica não inclui mais o Google Agenda: suas consultas pararam de ser atualizadas lá.',
  // drugs_prescription_teplates
  'label/drugs_prescription_teplates/list/title': 'Modelos de Prescrição',
  'label/drugs_prescription_teplates/list/empty_title': 'Nenhum modelo de prescrição',
  'label/drugs_prescription_teplates/list/empty_hint': 'Salve aqui as prescrições que você mais faz. Ao fazer uma prescrição no computador, é só escolher o modelo em “Modelos Salvos”.',
  'label/drugs_prescription_teplates/list/new': 'Novo Modelo',
  'label/drugs_prescription_teplates/list/new_prescription': 'Nova Prescrição',
  'label/drugs_prescription_teplates/form/error_empty': 'não pode estar vazio',
  'label/drugs_prescription_teplates/form/placeholder_content': 'Digite aqui o conteúdo da prescrição',
  'label/drugs_prescription_teplates/form/controlled_checkbox': 'Receituário Controlado',
  'label/drugs_prescription_teplates/form/model_name': 'Nome do Modelo',
  // exams models
  'label/exam_models/list/title': 'Modelos de Pedido de Exames',
  'label/exam_models/list/empty_title': 'Nenhum modelo de pedido de exames',
  'label/exam_models/list/empty_hint': 'Salve aqui os pedidos de exames que você mais faz. Ao fazer um pedido de exames no computador, é só escolher o modelo em “Modelos Salvos”.',
  'label/exam_models/list/new_exam': 'Novo Modelo',
  'label/exam_models/form/error_empty': 'não pode estar vazio',
  'label/exam_models/form/placeholder_content': 'Digite aqui o conteúdo do pedido de exames',
  'label/exam_models/form/model_name': 'Nome do Modelo',
  // documents
  'label/documents/list/title': 'Modelos de Documento',
  'label/documents/list/empty_title': 'Nenhum modelo de documento',
  'label/documents/list/empty_hint': 'Salve aqui atestados, declarações e outros documentos que você mais usa. Ao fazer um documento no computador, é só escolher o modelo em “Modelos Salvos”.',
  'label/documents/list/new_doc': 'Novo Modelo',
  'label/documents/form/title': 'Modelo de Documento',
  'label/documents/form/name': 'Nome do Modelo',
  'label/documents/form/error_empty': 'não pode estar vazio',
  'label/documents/form/placeholder_content': 'Digite aqui o conteúdo do documento',
  'label/documents/form/show_print_model': 'Mostrar o nome do modelo ao imprimir',
  // the three template lists
  'label/templates/empty_action': 'Criar modelo',
  'label/templates/load_error': 'Não conseguimos carregar os modelos. Confira a conexão e abra a página de novo.',
  // Clinic config address
  'label/clinic_addr/title': 'Dados da Clínica/Consultório',
  'label/clinic_addr/clinic_name': 'Nome do Consultório/Clínica',
  'label/clinic_addr/title2': 'Endereço da Clínica',
  // Clinic doctors
  'label/clinic_doctors/form/title_edit': 'Editar Profissional',
  'label/clinic_doctors/form/title_invite': 'Convidar Profissional de Saúde',
  'label/clinic_doctors/form/name_in_receipt': 'Nome completo para recibos',
  'label/clinic_doctors/form/council_doc': 'Conselho Profissional',
  'label/clinic_doctors/form/agenda_color': 'Cor na Agenda',
  'label/clinic_doctors/form/agenda_info': 'Informações na Agenda',
  'label/clinic_doctors/form/default_appointment_duration': 'Tempo Padrão de Atendimento',
  'label/clinic_doctors/form/default_room': 'Sala Padrão de Atendimento',
  'label/clinic_doctors/form/video_url': 'Link da Sala Online',
  'label/clinic_doctors/form/video_url_hint': 'O link fixo da chamada (Google Meet, Zoom...). As consultas online usam este link quando não têm um próprio.',
  'label/clinic_doctors/form/is_administrator': 'Administrador',
  'label/clinic_doctors/form/edit_workhours': 'Configurar Horários de Atendimento',
  'label/clinic_doctors/form/administrator_hint': 'Administradores podem alterar as configurações e ver os relatórios financeiros completos.',
  // Doctors workhours
  'label/doctors_workhours/title': 'Horários de Atendimento',
  'label/doctors_workhours/weekday': 'Dia da semana',
  'label/doctors_workhours/title2': 'Adicionar novo horário de atendimento',
  // secretaries
  'label/secretaries/list/empty': 'Convide sua secretária',
  'label/secretaries/list/hint_1': 'Vocês podem usar o Doutore ao mesmo tempo.',
  'label/secretaries/list/hint_2': 'Todas as informações sincronizam automaticamente.',
  'label/secretaries/form/edit_secretary': 'Editar Secretária',
  'label/secretaries/form/manager_hint': 'Administradores podem alterar as configurações e ver os relatórios financeiros completos',
  // team (Ajustes › Equipe, the Painel de Controle's "Gerenciar Equipe")
  'label/team/title': 'Equipe',
  'label/team/summary': '({{doctors}}, {{secretaries}})',
  'label/team/doctors_count_one': '{{count}} profissional',
  'label/team/doctors_count_other': '{{count}} profissionais',
  'label/team/secretaries_count_one': '{{count}} secretária',
  'label/team/secretaries_count_other': '{{count}} secretárias',
  'label/team/doctors': 'Profissionais de Saúde',
  'label/team/secretaries': 'Secretárias',
  'label/team/invite_doctor': 'Convidar Profissional',
  'label/team/invite_secretary': 'Convidar Secretária',
  'label/team/doctor_limit_reached': 'Limite de profissionais atingido. Atualize seu plano para adicionar mais.',
  'label/team/secretary_limit_reached': 'Seu plano permite apenas uma secretária. Atualize seu plano para adicionar mais.',
  'label/team/doctor_limit_reached_review': 'Limite de profissionais do plano atingido.',
  'label/team/secretary_limit_reached_review': 'O plano permite apenas uma secretária.',
  'label/team/limit': 'Sua assinatura permite até {{limit}} profissionais de saúde. Atualmente você possui {{count}}/{{limit}}.',
  'label/team/limit_reached': 'Sua assinatura permite até {{limit}} profissionais de saúde. Você já atingiu este limite ({{count}}/{{limit}}).',
  'label/team/deal_summary': 'Detalhes da assinatura',
  'label/team/owner': 'Responsável',
  'label/team/manager': 'Administrador',
  'label/team/no_doctors': 'Nenhum profissional de saúde nesta clínica.',
  'label/team/support': 'Dúvidas sobre sua equipe ou plano?',
  'label/team/support_action': 'Falar com o Suporte',
  'label/team/managers_only': 'Só os administradores da clínica podem gerenciar a equipe.',
  'label/team/load_error': 'Não conseguimos carregar a equipe. Confira a conexão e abra a página de novo.',
  'label/team/remove': 'Remover da clínica',
  'label/team/owner_always_manager': 'O responsável pela clínica é sempre administrador.',
  'label/team/not_allowed': 'Você só pode alterar o seu próprio cadastro.',
  'label/team/own_access': 'Você não pode alterar o seu próprio acesso de administrador.',
  'label/team/clinic_settings': 'Configurações na Clínica',
  // Agenda
  'label/agenda_menu/workhours': 'Horários de Funcionamento',
  'label/agenda_menu/rooms': 'Salas de Atendimento',
  'label/agenda_menu/title': 'Agenda',
  'label/agenda/show_saturday_in_agenda': 'Mostrar sábado na agenda',
  'label/agenda/show_sunday_in_agenda': 'Mostrar domingo na agenda',
  // Clinic rooms
  'label/rooms/title': 'Salas de Atendimento',
  'label/rooms/room_name': 'Nome da Sala',
  'label/rooms/title2': 'Dados da Clínica/Consultório',
  'label/rooms/number_of_rooms': 'Número de Salas',
  // Patient fields
  'label/patients_fields/title_mobile': 'Cadastro de Pacientes',
  'label/patients_fields/basic_data': 'Dados básicos',
  'label/patients_fields/hint': 'Exibir campos extras no cadastro de paciente',
  'label/patients_fields/code': 'Código',
  'label/patients_fields/custom_field': 'Campo Personalizavel',
  'label/patients_fields/health_insurance': 'Plano de Saúde',
  'label/patients_fields/health_insurance_fields': 'Convênio, Plano, Número da carteira e Validade',
  // tags
  'label/tags/list/title': 'Lista de Etiquetas',
  'label/tags/list/new': 'Nova Etiqueta',
  'label/tags/form/edit': 'Editar Etiqueta',
  'label/tags/form/title': 'Etiquetas',
  // Service templates
  // the two lists of the Tabela de Serviços (the Painel de Controle's)
  'label/services/shared/title': 'Serviços compartilhados',
  'label/services/shared/description': 'Disponíveis para todos os profissionais da clínica.',
  'label/services/shared/new': 'Novo compartilhado',
  'label/services/shared/empty': 'Nenhum serviço compartilhado',
  'label/services/shared/empty_hint': 'Cadastre aqui os serviços que todos os profissionais oferecem.',
  'label/services/shared/managers_only': 'Só os administradores da clínica alteram os serviços compartilhados.',
  'label/services/shared/option': 'Todos os profissionais (compartilhado)',
  'label/services/doctor/title': 'Serviços do profissional',
  'label/services/doctor/description': 'Disponíveis só para o profissional escolhido.',
  'label/services/doctor/description_for': 'Disponíveis só para {{name}}.',
  'label/services/doctor/new': 'Novo serviço',
  'label/services/doctor/not_allowed': 'Você só pode alterar os seus próprios serviços.',
  'label/services/doctor/empty': 'Nenhum serviço deste profissional',
  'label/services/doctor/empty_hint': 'Cadastre aqui os serviços e valores próprios deste profissional.',
  'label/services/form/available_to': 'Disponível para',
  'label/services/form/owner_locked': 'Não muda depois de criado.',
  'label/services/form/edit_shared': 'Editar Serviço Compartilhado',
  'label/services/form/new_shared': 'Novo Serviço Compartilhado',
  'label/services/print': 'Imprimir tabela',
  'label/services/search_empty': 'Não foram encontrados serviços para o termo pesquisado.',
  'label/services/add_service': 'Adicionar Serviço',
  'label/services/private': 'Particular',
  'label/services/form/new_service': 'Novo Serviço',
  'label/services/form/by_quantity': 'Vendido por quantidade',
  'label/services/form/by_quantity_hint': 'Na venda você informa a quantidade e o valor é multiplicado.',
  'label/services/form/unit': 'Unidade',
  'label/services/form/unit_suggestions': 'U,seringa,ml,frasco,fio,sessão,disparo',
  'label/services/form/unit_value': 'Valor por {{unit}}',
  'label/services/form/unit_value_default': 'Valor por unidade',
  'label/services/form/error/unit': 'Informe a unidade',
  'label/services/form/error/unit_length': 'Use até 20 caracteres',
  // Printing
  'label/print_config/menu/general': 'Geral',
  'label/print_config/menu/logo': 'Logo da Clínica',
  'label/print_config/menu/eletronic_receipts': 'Receituário Eletrônico',
  'label/print_config/menu/controlled_receipts': 'Receituário Controlado',
  'label/print_config/menu/clinic_logo': 'Logo da Clínica',
  'label/print_config/menu/title': 'Impressão',
  'label/print_config/general/clinic_name': 'Nome do Consultório/Clínica',
  'label/print_config/general/title': 'Layout de Relatórios',
  'label/print_config/prescription/letterhead': 'Papel Timbrado',
  'label/print_config/prescription/nohead': 'Papel em Branco',
  'label/print_config/prescription/paper_type': 'Que tipo de papel você irá colocar na impressora?',
  'label/print_config/prescription/line': 'Linha',
  'label/print_config/prescription/heading': 'Cabeçalho',
  'label/print_config/prescription/line_1': 'Título do Cabeçalho',
  'label/print_config/prescription/line_2': 'Texto do Cabeçalho',
  'label/print_config/prescription/preview_pdf': 'Ver Exemplo',
  'label/print_config/prescription/footer': 'Texto do Rodapé',
  'label/print_config/prescription/margins': 'Margens',
  'label/print_config/prescription/font': 'Fonte',
  'label/print_config/prescription/margin_top': 'Margem Superior',
  'label/print_config/prescription/margin_bottom': 'Margem Inferior',
  'label/print_config/prescription/margin_left': 'Margem Esqueda',
  'label/print_config/prescription/margin_right': 'Margem Direita',
  'label/print_config/prescription/title': 'Configurações de Impressão',
  'label/print_config/controlled/title': 'Receituário Controlado',
  'label/print_config/controlled/council_number': 'Numero do conselho',
  // Support
  'label/support/menu/terms': 'Termos de Uso',
  'label/support/menu/backup': 'Backup Manual',
  'label/support/menu/to_appx': 'Ir para o Doutore (Versão Beta)',
  'label/support/menu/to_app': 'Ir para o Doutore 4 (Versão Atual)',
  'label/support/menu/chat': 'Suporte por Chat Online',
  'label/support/menu/refresh': 'Atualizar o Doutore',
  'label/support/menu/privacyPolicy': 'Política de Privacidade',
  'label/support/menu/deleteMyAccount': 'Deletar Minha Conta',
  'label/support/menu/version': 'Doutore versão',
  'label/support/backup/success/title': 'Tudo certo!',
  'label/support/backup/success/text': 'Iremos processar as suas informações e enviaremos para o seu email',
  'label/support/backup/title': 'Backup Manual',
  'label/support/backup/text/line1': 'No Doutore, seus dados ficam seguros armazenados nos nossos servidores.',
  'label/support/backup/text/line2': 'Fazemos backup diário automático de todas as suas informações e armazenamos o backup em diferentes localidades no mundo: Estados Unidos, São Paulo e Europa.',
  'label/support/backup/text/line3': 'Se mesmo assim você quiser fazer um backup manual do seus dados, utilize os botões abaixo:',
  'label/support/backup_excel/text/line1_title': 'Backup dos Pacientes em Excel: ',
  'label/support/backup_excel/text/line1': 'Planilha excel com os dados de cadastro dos pacientes.',
  'label/support/backup_excel/text/line2': 'Esse Backup é enviado diretamente para o seu email e pode demorar alguns minutos ou horas.',
  'label/support/backup_complete/text/line1_title': 'Backup Completo dos Prontuários:',
  'label/support/backup_complete/text/line1': 'Arquivo com todos os prontuários e fotos dos pacientes.',
  'label/support/backup_complete/text/line2': 'Como esse backup utiliza muito processamento dos nossos servidores, ele é feito apenas em momentos de baixa utilização do sistema, para não afetar a performance do Doutore. Esse Backup é feito manualmente e pode demorar horas ou dias.',
  'label/support/backup/request_backup_patients': 'Pedir Backup dos Pacientes',
  'label/support/backup/request_backup_complete': 'Pedir Backup Completo',
  'label/support/backup/support_action_lbl': 'Em caso de dúvidas',
  'label/support/backup/support_action_btn': 'entre em contato',
  'label/support/backup/attention': 'Atenção',
  'label/support/backup/wait': 'Aguarde...',
  'label/support/backup/manager_only/title': 'Só os administradores da clínica podem pedir o backup manual.',
  'label/support/backup/manager_only/text': 'Se precisar dos dados, peça a um deles: o backup vai para o e-mail de quem pediu.',
  'label/support/backup/attention_text': `Como o backup manual utiliza muito processamento dos nossos servidores,
  ele é feito apenas em momentos de baixa utilização do sistema, para não afetar a performance do Doutore.
  Isso pode levar algumas horas.`,
  // menu
  'action/menu/my_plan': 'Meu Plano',
  'action/menu/plans': 'Planos',
  'action/menu/my_record': 'Meu Cadastro',
  'action/menu/google_calendar': 'Google Agenda',
  'action/menu/records_settings': 'Ajustes de Prontuário',
  'action/menu/privacy': 'Privacidade',
  'action/menu/forms': 'Formulários',
  'action/menu/eletronic_records': 'Receituário Eletrônico',
  'action/menu/clinic_settings': 'Ajustes da Clínica',
  'action/menu/my_clinic': 'Minha Clínica',
  'action/menu/team': 'Equipe',
  'action/menu/agenda': 'Agenda',
  'action/menu/patients_data': 'Cadastro de Pacientes',
  'action/menu/advanced_settings': 'Ajustes Avançados',
  'action/menu/tags': 'Etiquetas',
  'action/menu/sevices_list': 'Tabela de Serviços',
  'action/menu/printing': 'Impressão',
  'action/menu/support': 'Suporte Técnico',
  'action/menu/logout': 'Sair do Doutore',
  'action/remove_logo': 'Remover Logo',
  'action/select_clinic_logo': 'Enviar Logo da Clínica',
  'action/train_secretary': 'Quero que entre contato para treinar minha secretária',
  'label/no_clinic_logo': 'Arraste aqui sua logo',
  'label/drop_logo': 'Solte sua logo aqui.',
  'label/backup_request_blocked': 'Você não tem acesso a esta funcionalidade',
  'label/action/change_clinic': 'Alterar',
  'action/menu/change_clinic_title': 'Selecione uma clínica',
};
